<script>
import CustomButton from '@/components/ui/buttons/CustomButton.vue'
import { useRouter } from 'vue-router'
import { computed, toRefs } from 'vue'
import { gosuslugiListner } from '@/utilits/gosuslugiListner'
import { postLog } from '@/api/postLog'
import { useYandexMetrikaStore } from '@/stores/YandexMetrikaStore'

export default {
  name: 'GosuslugiButton',
  components: { CustomButton },
  props: {
    phoneUrl: {
      type: String,
      required: true,
      default: ''
    },
    webUrl: {
      type: String,
      required: true,
      default: ''
    },
    metrikaGoal: {
      type: String,
      required: true,
      default: ''
    },
    redirectUrl: {
      type: String,
      required: true,
      default: ''
    },
    tokenKey: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup (props) {
    const { phoneUrl, webUrl, metrikaGoal, redirectUrl, tokenKey } =
      toRefs(props)
    const metrikaStore = useYandexMetrikaStore()
    const router = useRouter()
    const isPhone = computed(() => {
      const platform = window?.device?.platform.toLowerCase()
      return platform === 'ios' || platform === 'android'
    })
    const authGosuslugi = () => {
      metrikaStore.sendGoal(metrikaGoal.value)
      if (isPhone.value) {
        gosuslugiListner(phoneUrl.value)
          .then((event) => {
            let token

            postLog({
              event: `event esia ${event}`,
              eventParse: `event ${JSON.parse(event.data.substring(7))}`
            })

            if (event.data.match(/^oauth::/)) {
              token = JSON.parse(event.data.substring(7))
            }

            postLog({
              token: token[tokenKey.value]
            })

            router.push(
              redirectUrl.value +
                encodeURIComponent(token[tokenKey.value]).toString()
            )
          })
          .catch((err) => {
            postLog({
              err: err
            })
            router.push('/404')
          })

        return
      }

      window.location = webUrl.value
    }

    return {
      authGosuslugi
    }
  }
}
</script>

<template>
  <div class="stage-gosuslugi">
    <div class="stage-gosuslugi__top">
      <CustomButton
        @click="authGosuslugi"
        class="stage-gosuslugi__btn"
        tag="button"
        white
        type="button"
        marginBottom="20px"
      >
        <template #img>
          <img
            src="@/assets/uploads/icon/common/gosuslugi.svg"
            alt="логотип Госуслуг"
          />
        </template>
        Войти через Госуслуги
      </CustomButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.stage-gosuslugi {
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  text-align: center;

  & p {
    margin-bottom: 25px;
    text-wrap: balance;
  }
}

.register-new__radio-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-left: 15px;
  text-align: start;
  margin-bottom: 20px;
}

.stage-gosuslugi__btn {
  padding-top: 1px;
  padding-bottom: 1px;
  max-width: 290px;
  margin: 0 auto;
}

.stage-gosuslugi__error {
  color: $red;

  & h4 {
    margin-bottom: 16px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
  }

  & p {
    text-align: center;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
